class SessionManager {
    static setItem(name, value) {
        // Null is stored as an empty string and we want real null values to be returned.
        if (value == null) {
            sessionStorage.removeItem(name);
        }
        else {
            sessionStorage.setItem(name, value);
        }
    }

    static getItem(name) {
        return sessionStorage.getItem(name);
    }

    static removeItem(name) {
        sessionStorage.removeItem(name);
    }

    static removeAllItems() {
        sessionStorage.clear();
    } 
}

export default SessionManager;


// WEBPACK FOOTER //
// ./src/services/SessionManager.js